<section id="filterContainer">
    <article class="pl-5 pt-5">
        <h1 class="title">{{ literalService.get('filterBy', true) }}</h1>
    </article>
    <article class="lg:flex sm:relative pl-5 pt-5 pr-5 place-content-between">
        @if (showClients) {
            <label class="w-48 text-center title-columns mr-4">{{ literalService.get('users.data.clients', true) }}</label>
        }
        <label class="w-48 text-center title-columns mr-4">{{ literalService.get('sidebar.operators', true) }}</label>
        <label class="w-48 text-center title-columns mr-4">{{ literalService.get('bookings.services', true) }} - {{ literalService.get('bookings.routes', true) }}</label>
        <label class="w-48 text-center title-columns mr-4">{{ literalService.get('trips.type', true) }}</label>
        <label class="w-48 text-center title-columns mr-4">{{ literalService.get('trips.status', true) }}</label>
    </article>
    <form #form novalidate>
        <article class="lg:flex sm:relative pl-5 pt-5 pr-5">
            @if (showClients) {
                <article class="lg:flex rounded w-48 h-12 items-center mr-4">
                    <app-multi-select-form [title]="'trip-clients'" [elements]="clients" [values]="selectedValuesClients" [width]="'48'" />
                </article>
            }
            <article class="lg:flex rounded w-48 h-12 items-center mr-4">
                <app-multi-select-form [title]="'trip-operators'" [elements]="operators" [values]="selectedValuesOperators" [width]="'48'" />
            </article>
            <article class="mr-4">
                <article class="lg:flex rounded w-48 items-center mb-2">
                    <app-input
                        class="w-48"
                        [data]="servicesElement"
                        [edit]="true"
                        [independent]="true"
                        (setEventEmitter)="onServicesChange($event.value)"
                        (scrollEventEmitter)="onScroll($event, servicesElement.edit?.valueToChange)"
                        (searchEventEmitter)="onSearch($event, servicesElement.edit?.valueToChange)"
                    />
                </article>
                <article class="lg:flex rounded w-48 items-center mb-2">
                    <app-input
                        class="w-48"
                        [data]="routesElement"
                        [edit]="true"
                        [independent]="true"
                        (setEventEmitter)="onRoutesChange($event.value)"
                        (scrollEventEmitter)="onScroll($event, routesElement.edit?.valueToChange)"
                        (searchEventEmitter)="onSearch($event, routesElement.edit?.valueToChange)"
                    />
                </article>
            </article>
            <article>
                @for (type of expeditionTypes; track $index) {
                    <label class="flex box pt-2 pb-2 pl-4 pr-4 rounded w-48 h-12 mr-4 mb-2 items-center bg-white cursor-pointer">
                        <input type="checkbox" class="mr-2 cursor-pointer" [checked]="type.checked" (change)="type.checked = !type.checked" />
                        {{ literalService.get(type.value, true) }}
                    </label>
                }
            </article>
            <article>
                @for (status of expeditionStatus; track $index) {
                    <label class="flex box pt-2 pb-2 pl-4 pr-4 rounded w-48 h-12 mr-4 mb-2 items-center cursor-pointer" [ngClass]="!closedStatusSelected ? 'bg-white' : 'bg-gray-100'">
                        <input type="checkbox" class="mr-2 cursor-pointer" [checked]="status.checked" [disabled]="closedStatusSelected" (change)="!closedStatusSelected && status.checked = !status.checked"/>
                        {{ literalService.get('trips.' + status.value.toLowerCase(), true) }}
                    </label>
                }
                <label class="flex box pt-2 pb-2 pl-4 pr-4 rounded w-48 h-12 mr-4 mb-2 items-center cursor-pointer" [ngClass]="!closedStatusSelected ? 'bg-white' : 'bg-gray-100'">
                    <input type="checkbox" switch class="mr-2 cursor-pointer" [checked]="closedStatusSelected" (change)="onChangeExclusiveStatus('closed')" />
                    {{ literalService.get('trips.closed', true) }}
                </label>
            </article>
        </article>
        <article class="pt-10 pl-5 pb-5">
            <article class="flex pt-5 place-content-between">
                <div class="flex">
                    <label class="lg:flex box pt-2 pb-2 pl-4 pr-4 rounded w-48 h-12 mr-4 mb-2 items-center cursor-pointer">
                        <input #select id="selectAll" type="checkbox" class="mr-2 cursor-pointer" (change)="selectAll($event)" />
                        {{ literalService.get('selectAll', true) }}
                    </label>
                    <article class="lg:flex box pt-2 pb-2 pl-4 pr-4 rounded w-48 h-12 mr-4 mb-2 items-center bg-white cursor-pointer" (click)="clearSelection()">
                        <img class="mr-1 cursor-pointer" [src]="images.booking.actions.delete" alt="clear" />
                        <label class="cursor-pointer hover:underline">{{ literalService.get('clearSelection', true) }}</label>
                    </article>
                </div>
                <article class="lg:flex box pt-2 pb-2 pl-4 pr-4 rounded w-48 h-12 mr-4 mb-2 items-center">
                    <input type="button" class="primary text-white gap-4 p-2 border-2 font-semibold h-12 w-48 uppercase cursor-pointer" [value]="literalService.get('filter', true)" (click)="onSubmit(); closeFilter.emit()" />
                </article>
            </article>
        </article>
    </form>
</section>

